module.exports = __webpack_public_path__ + "img/U1F31E.3fe41c4e.png";